// Front-end route paths (canonical). The e-mail-bearing routes — confirmEmail and
// resetPassword — MUST stay byte-identical to the legacy app: the backend bakes
// them into sent e-mails via Url.Action, and old links live in inboxes for days.
// The rest are navigation-only. A few were renamed away from the misleading
// "/activeDirectory/" prefix (this app registers a *local* SSO user, not an AD
// object) onto a cleaner "/users" + "/mappings" scheme; legacyRedirects below
// keeps the old URLs resolving so existing bookmarks don't break.
export const Paths = {
    home: '/',
    login: '/login',
    adLogin: '/activeDirectory',
    authOptions: '/authOptions',
    logout: '/logout',
    register: '/users/new',
    smartStore: '/mappings',
    confirmEmail: '/activeDirectory/confirmEmail',
    forgotPassword: '/account/forgotPassword',
    resetPassword: '/account/resetPassword',
    addApplication: '/addApplication',
    updateRole: '/updateRole',
    usersOverview: '/users',
    generateToken: '/generateToken',
    adminStats: '/statistics',
    profile: '/profile',
    help: '/help',
} as const;

// Old paths kept alive as redirects → their new canonical target, so bookmarks
// and any stale links from before the rename still land on the right page.
export const legacyRedirects: Record<string, AppPath> = {
    '/activeDirectory/newUser': Paths.register,
    '/usersOverview': Paths.usersOverview,
    '/activeDirectory/smartStoreMappings': Paths.smartStore,
};

export type AppPath = (typeof Paths)[keyof typeof Paths];
